module.exports = __webpack_public_path__ + "static/media/but_class_continue.7a50a7c9.svg";